import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';

@Component({
  selector: 'app-video-player',
  templateUrl: './video-player.component.html',
  styleUrls: ['./video-player.component.css']
})
export class VideoPlayerComponent implements OnInit {
  @ViewChild('videoPlayer') videoplayer: ElementRef;
  @Input() videoSource="";

  constructor() {
  
  }

  ngOnInit(): void {
  }
  ngOnChange(){
  }
  toggleVideo(event: any) {
    this.videoplayer.nativeElement.load();
    this.videoplayer.nativeElement.play();
  }

  onCloseVideo=()=>{
    this.videoplayer.nativeElement.pause();
  }

}
